import { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

export default function DoughnutChart({ chartData, index }) {
  const [paddingRight, setPaddingRight] = useState(100);

  // Extract question and options
  const question = chartData?.questionDetails?.question || "Question";
  const options = chartData?.questionDetails?.options || [];

  // Extract data counts based on options
  const dataCounts = options.map((option) => chartData[option] || 0);

  // Prepare chart data
  const data = {
    labels: options.map((option) => {
      const total = dataCounts.reduce((a, b) => a + b, 0);
      return `${option} (${(((chartData[option] || 0) / total) * 100).toFixed(
        1
      )}%)`;
    }),
    datasets: [
      {
        label: "Number of Selections",
        data: dataCounts,
        backgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
          "#C9CBCF",
        ],
        hoverBackgroundColor: [
          "#FF6384",
          "#36A2EB",
          "#FFCE56",
          "#4BC0C0",
          "#9966FF",
          "#FF9F40",
          "#C9CBCF",
        ],
      },
    ],
  };

  // Optional: Custom options
  const optionsChart = {
    plugins: {
      legend: {
        position: "right",
        labels: {
          padding: 5,
          boxWidth: 30,
          boxHeight: 20,
        },
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            const label = context.label || "";
            const value = context.parsed;
            const total = dataCounts.reduce((a, b) => a + b, 0);
            const percentage = total ? ((value / total) * 100).toFixed(1) : 0;
            return `${label}: ${value} (${percentage}%)`;
          },
        },
      },
    },
    layout: {
      padding: {
        right: paddingRight,
      },
    },
    maintainAspectRatio: false,
  };

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setPaddingRight(width > 1680 ? 300 : width > 1460 ? 200 : 10);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  if (!chartData || !chartData?.questionDetails) return null;
  return (
    <div className=" bg-white p-5 2xl:py-5 2xl:px-10 rounded-[16px] mb-2">
      <h3 className="text-lg font-semibold  mb-4">
        {index + 1}
        {"."} {question}
      </h3>
      <div className="grid grid-cols-2">
        <ul className="list-disc px-4 text-sm">
          {options?.map((option, idx) => (
            <li key={idx}>{option}</li>
          ))}
        </ul>
        <div>
          <Doughnut data={data} options={optionsChart} />
        </div>
      </div>
    </div>
  );
}
